import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WStorePurchaseModal from './WStorePurchaseModal';
import WStorePurchaseWithTradeModal from './WStorePurchaseWithTradeModal';
import WStoreQuestModal from './WStoreQuestModal';

class WStoreModal extends Component {
  render() {
    if (
      this.props.selectedItem &&
      this.props.selectedItem.classCode === 'Quest'
    ) {
      return <WStoreQuestModal {...this.props} />;
    }

    if (this.props.selectedItem && this.props.purchaseWithTrade) {
      return <WStorePurchaseWithTradeModal {...this.props} />;
    }

    return <WStorePurchaseModal {...this.props} />;
  }
}

WStoreModal.propTypes = {
  selectedItem: PropTypes.object,
  userWScore: PropTypes.number,
  patronAssets: PropTypes.any,
  onPurchase: PropTypes.func,
  purchaseWithTrade: PropTypes.bool,
  purchaseRequested: PropTypes.bool,
  purchaseConfirmation: PropTypes.bool,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  purchaseError: PropTypes.bool,
  hidden: PropTypes.bool,
  onClose: PropTypes.func,
  exchangeRates: PropTypes.shape({
    wscorePerNugget: PropTypes.number,
    wscorePerRuby: PropTypes.number,
    wscorePerSapphire: PropTypes.number,
    wscorePerWChip: PropTypes.number
  })
};

export default WStoreModal;
